'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.callApi = undefined;

var _callApi = require('./call-api');

var _callApi2 = _interopRequireDefault(_callApi);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.callApi = _callApi2.default;


//////////////////
// WEBPACK FOOTER
// /Users/runner/work/1/s/engage.framework/lib/utils/index.js
// module id = 972
// module chunks = 2